import axios from "axios";
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

const API_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = secureStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const handleApiError = (error) => {
  if (error.response) {
    const message = error.response.data?.message || "Error desconocido del servidor.";
    throw new Error(message);
  }
  if (error.request) {
    throw new Error("Sin respuesta del servidor. Verifique su conexion.");
  }
  throw new Error(`Error inesperado: ${error.message}`);
};

const fetchAccesoEventos = async () => {
  try {
    const response = await api.get("acceso-eventos");
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

const fetchAccesoEventoById = async (id) => {
  if (id === undefined || id === null || id === "") {
    throw new Error("El identificador es requerido.");
  }
  try {
    const response = await api.get(`acceso-eventos/${id}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

const createAccesoEvento = async (payload) => {
  try {
    const { id, ...body } = payload;
    const response = await api.post("acceso-eventos", body);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

const updateAccesoEvento = async (id, payload) => {
  if (id === undefined || id === null || id === "") {
    throw new Error("El identificador es requerido para actualizar.");
  }
  try {
    const { id: omitted, ...body } = payload;
    const response = await api.put(`acceso-eventos/${id}`, body);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export {
  fetchAccesoEventos,
  fetchAccesoEventoById,
  createAccesoEvento,
  updateAccesoEvento,
};
